
if (!customElements.get('products-slider')) {
  customElements.define(
    'products-slider',
    class ProductsSlider extends HTMLElement {
      constructor() {
        super();
        this.swiper = null;
        this.descriptions = null;
      }

      connectedCallback() {
        this.descriptions = document.querySelectorAll('.products-slider__descriptions  .richtext');
        this.initSwiper();
      }

      initSwiper() {
        this.swiper = new Swiper('.products-slider', {
          slidesPerView: 1.5,
          allowTouchMove: true,
          spaceBetween: 24,
         
          navigation: {
            nextEl: '.products-slider__next',
            prevEl: '.products-slider__prev',
          },
          pagination: {
            bulletClass: "pagination__number",
            bulletActiveClass: "active",
            el: ".products-slider__pagination",
            clickable: true,
            renderBullet: function(index, className) {
              return '<span class="' + className + '">' + '0' + (index + 1) + '</span>';
            }
          },
          breakpoints: {
            0: {
              slidesPerView: 1,
              centeredSlides: true,
              spaceBetween: 16,
            },
            481: {
              slidesPerView: 1.5,
            },
            750: {
              slidesPerView: 1,
              centeredSlides: false,
            },
            1280: {
              slidesPerView: 1.5,
              spaceBetween: 24
            },
            1441: {
              slidesPerView: 'auto',
              slidesOffsetAfter: 200,
            }
          },
          on: {
            slideChange: (event) => {
              if (this.descriptions.length) {
                this.descriptions.forEach(el => {
                  el.dataset.index == event.activeIndex ? el.classList.remove('hidden') : el.classList.add('hidden');
                });
              }
            }
          }
        });
      }
    }
  );
}





